import React from 'react';
import ErrorPage from '../../components/ErrorPage';

const NotFoundPage = (props) => {
    const {
        errorMessage = 'Page not found.',
        onBackClick,
    } = props;

    return (
        <ErrorPage
            subtitle={errorMessage}
            showReloadButton={false}
            showBackButton={true}
            onBack={onBackClick}
            data-testid="error-404.error-page"
        />
    );
};

export default NotFoundPage;
